import { render, staticRenderFns } from "./list_config_dataset_field.vue?vue&type=template&id=c7ad95fa"
import script from "./list_config_dataset_field.vue?vue&type=script&lang=js"
export * from "./list_config_dataset_field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports